export default __webpack_public_path__ + "static/media/lunch.68d27597.76e298a5.svg";